import OtherRetirementAccounts from "../OtherRetirementAccounts";

export default function RtqOtherRetirementAccounts({
  advanceScreen,
  previousScreen,
  validation,
  updateValidation,
  screen,
}) {
  return <OtherRetirementAccounts
    advanceScreen={advanceScreen}
    previousScreen={previousScreen}
    validation={validation}
    updateValidation={updateValidation}
    screen={screen}
  />
}
